import React from "react";
import Card from "react-bootstrap/Card";
import PersonImage from "./PersonImage";

export default function PersonCard(props) {
    const person = props.person;
    return (
        <Card style={{overflow: 'hidden', marginBottom: '0px', backgroundColor: "rgba(240, 240, 240)"}}>
            <Card.Body style={{padding: 0}}>
                <div style={{
                    float: 'left', margin: '0px', color: 'rgb(200, 200, 200)',
                    paddingRight: '15px'
                }}>
                    <PersonImage imageName={person.image}/>
                </div>
                <div style={{padding: '10px'}}>
                    <Card.Title>{person.name}</Card.Title>
                    <Card.Text style={{fontSize: 13}} dangerouslySetInnerHTML={{__html: person.short_bio}} />
                </div>
            </Card.Body>
        </Card>
    );
}
